import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {IEntryStore} from './entry.stores';
import {EntryComponent} from '../../../components/entry/entry/Entry.component';

interface EntryViewProps {
    entryStore: IEntryStore;
}

@observer
export class EntryViewComponent extends TechseeBaseComponent<EntryViewProps> {
    renderInternal(): JSX.Element {
        const {entryStore} = this.props;

        if (!entryStore?.entryController) {
            return <React.Fragment />;
        }

        return <EntryComponent ctrl={entryStore.entryController} />;
    }
}

export const EntryView = inject('entryStore')(EntryViewComponent) as IReactComponent;
